import React from "react";

export interface HighlightOverlayProps {
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  color?: string;
  opacity?: number;
}

export const HighlightOverlay: React.FC<HighlightOverlayProps> = ({
  x = 0,
  y = 0,
  width = 800,
  height = 450,
  color = "#facc15",
  opacity = 0.25,
}) => (
  <rect x={x} y={y} width={width} height={height} rx={8} ry={8} fill={color} opacity={opacity} />
);
